<template>
    <v-autocomplete
        v-model="selectedProjectFolder"
        :items="projectFolderOptions"
        label="Project (*)"
        item-title="path"
        item-value="folderId"
        :rules="requiredSimpleValueRules('Project')"
        return-object
        clearable
    />
</template>
<script setup lang="ts">
import { benchlingAPI, BenchlingProjectFolderOption } from "@/services/benchling/benchlingAPI";
import { ref } from "vue";
import type { Ref } from "vue";
import { withLoadingScreen } from "@/lib/loading";
import { requiredSimpleValueRules } from "@/lib/validationUtils";

const selectedProjectFolder = defineModel<BenchlingProjectFolderOption | undefined>();
const projectFolderOptions: Ref<BenchlingProjectFolderOption[]> = ref([]);


withLoadingScreen(async () => {
    projectFolderOptions.value = await benchlingAPI.fetchProjectFolderOptions();
});

</script>
